import styled from "styled-components";
import { device } from "../../../utils/device";

export const ViewOne = styled.div`
  width: 350px;
  margin-right: auto;
  margin-left: auto;
  min-width: 100px;
  max-height: ${(props) => (props.isFormPreview ? "none" : "90vh")};
  background: ${(props) =>
    props.isDefault
      ? `linear-gradient(
      144.96deg,
      #ffffff 0%,
      #ffffff 35%,
      rgba(255, 255, 255, 0.9) 45%,
      rgba(204, 254, 255, 0.7) 55%,
      rgba(247, 254, 213, 0.7) 70%,
      rgba(253, 207, 254, 0.7) 85%,
      rgba(245, 238, 222, 0.8) 100%
    ),
    linear-gradient(0deg, rgba(255, 255, 255, 0.4) 0%, #ffffff 100%)`
      : "#ffffff"};
  padding: 24px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  overflow: ${(props) => (props.isFormPreview ? "visible" : "auto")};
  gap: 10px;
  border: ${(props) => props.isGalleryBbox && "1px solid #BBBBBB"};
  position: relative; /* Ensure parent is relative for absolute positioning */

  /* Default business box should fill available height */
  ${(props) =>
    props.isDefault &&
    props.isGalleryBbox &&
    `
    height: 98%;
    justify-content: space-between;
  `}

  /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  /* Form preview specific styles */
  ${(props) =>
    props.isFormPreview &&
    `
    position: relative;
  `}

  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;

  @media (${device.mobilePortrait}) {
    width: 94vw;
    position: relative;
    right: auto;
    left: auto;
    top: auto;
    background: #e3efeb;
    z-index: 200;
    max-height: ${(props) =>
      props.isFormPreview ? "none" : "calc(100svh - 18svh - 6vw)"};
    overflow: ${(props) => (props.isFormPreview ? "visible" : "scroll")};

    p {
      text-align: center !important;
    }

    img {
      width: 100% !important;
    }
  }

  ${({ isMobilePortrait, isFormPreview }) =>
    isMobilePortrait &&
    `
    width: 94vw;
    position: relative;
    right: auto;
    left: auto;
    top: auto;
    background: #e3efeb;
    z-index: 200;
    max-height: ${isFormPreview ? "none" : "calc(100svh - 15svh - 6vw)"};
    overflow: ${isFormPreview ? "visible" : "scroll"};

    p {
      text-align: center !important;
    }

    img {
      width: 100% !important;
    }`}
`;

export const IconContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  gap: ${(props) => (props.isDefault ? "35px" : "25px")};
  margin: ${(props) => (props.isDefault ? "30px auto 0" : "10px auto 0")};
  max-width: fit-content;
`;

export const IconWrapper = styled.div`
  cursor: pointer;
`;
